import { useState, useEffect } from 'react';

export default function StickyBookingBar() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 600);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-50 transition-all duration-500 ${
        visible
          ? 'translate-y-0 opacity-100'
          : 'translate-y-full opacity-0 pointer-events-none'
      }`}
    >
      <div className="bg-black/95 backdrop-blur-md border-t border-white/10 shadow-[0_-4px_20px_rgba(0,0,0,0.3)]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-3 sm:py-3.5 flex items-center justify-between gap-3 sm:gap-6">
          {/* Left info */}
          <div className="hidden sm:flex items-center gap-4 text-white/70 text-xs font-extralight shrink-0">
            <div className="flex items-center gap-1.5">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-map-pin-2-fill text-emerald-400 text-sm" aria-hidden="true"></i>
              </div>
              <span>favy 新宿</span>
            </div>
            <div className="w-px h-3 bg-white/20"></div>
            <div className="flex items-center gap-1.5">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-time-fill text-emerald-400 text-sm" aria-hidden="true"></i>
              </div>
              <span>9:00〜23:00</span>
            </div>
            <div className="w-px h-3 bg-white/20"></div>
            <span className="text-white/50">ドロップイン 550円/30分〜</span>
          </div>

          {/* Right buttons */}
          <div className="flex items-center gap-2 sm:gap-3 w-full sm:w-auto">
            <a
              href="https://appointment.mever.design/"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="flex-1 sm:flex-none inline-flex items-center justify-center px-5 sm:px-6 py-2.5 sm:py-3 bg-white text-black text-xs sm:text-sm font-medium tracking-wide hover:bg-white/90 transition-colors whitespace-nowrap rounded-lg cursor-pointer"
            >
              <i className="ri-calendar-check-line mr-1.5" aria-hidden="true"></i>
              MeVER Chair 体験予約
            </a>
            <a
              href="https://pass.workhub.site/spaces/drop-in/detail/KmPzAOl3HSsGdIqqdLxK"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="flex-1 sm:flex-none inline-flex items-center justify-center px-5 sm:px-6 py-2.5 sm:py-3 bg-emerald-500 text-white text-xs sm:text-sm font-light tracking-wide hover:bg-emerald-600 transition-colors whitespace-nowrap rounded-lg cursor-pointer"
            >
              ドロップイン予約
              <i className="ri-external-link-line ml-1.5" aria-hidden="true"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
